import { Content } from "pdfmake/interfaces";
import HeaderSapiensForm from "react-lib/apps/HISV3/DPO/sequence/HeaderSapiensForm";

import CONFIG from "config/config";

const FormWorkScheduleReport = async (props: any) => {
  var origin = window?.location?.origin;

  const getHospitalAddress = (): Content => {
    return {
      columns: [
        { text: '', width: '*' },
        {
          width: 'auto',
          table: {
            body: [
              [
                {
                  alignment: 'right',
                  margin: [0, 0, 5, 0],
                  border: [false, false, true, false],
                  stack: [
                    {
                      font: 'KanitLM',
                      style: 'hospitalName',
                      text: 'โรงพยาบาลเอ็มเอสเค',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'เลขที่ 118 ถ. สาทรเหนือ แขวงสีลม',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'เขตบางรัก กรุงเทพมหานคร 10500',
                    },
                  ],
                },
                {
                  alignment: 'right',
                  margin: [5, 0, 0, 0],
                  border: [true, false, false, false],
                  stack: [
                    {
                      font: 'KanitLM',
                      style: 'hospitalName',
                      text: 'MSK Hospital',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: '118, Sathon Nuea Rd., Silom,',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'Bang Rak, Bangkok 10500',
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: (i) => (i === 1 ? 0.75 : 0),
            vLineColor: () => 'black',
          },
        },
      ],
      margin: [0, 0, 20, 0]
    };
  };

  const headerSapiensForm = await HeaderSapiensForm({
    form: "FormReceipt",
    logoHight: CONFIG.COMPANY === "MSK" ? 60 : 24,
    pageMargins: props?.pageMargins || [0, 115, 0, 30],
    hospitalAddress: getHospitalAddress(),
    titleMargins: [0, 16, 0, 0],
    logoMargins: [0, -8, 0, 0],
    header: {
      margin: [-8, 0, 0, 0],
      stack: [
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: [
                    {
                      text: "Work Schedule Report sorted by Date and Shift",
                      font: "KanitLM",
                      style: {
                        bold: true,
                        fontSize: 12,
                      },
                    },
                  ],
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
        },
        {
          columns: [
            {
              width: "auto",
              margin: [20, 0, 2, 0],
              text: { 
                text: "Unit:", 
                font: "KanitLM", 
                style: "reportHeader" 
              },
            },
            {
              width: "auto",
              text: { 
                text: props.params.unit, 
                font: "KanitLM", 
                style: "reportInfo" 
              },
            },
            {
              width: "auto",
              margin: [20, 0, 2, 0],
              text: { 
                text: "Month:", 
                font: "KanitLM", 
                style: "reportHeader" 
              },
            },
            {
              width: "auto",
              text: { 
                text: props.params.month, 
                font: "KanitLM", 
                style: "reportInfo" 
              },
            },
          ],
          alignment: "left",
        }
      ],
    },
    styles: {
      reportHeader: {
        bold: true,
        fontSize: 8,
      },
      reportInfo: {
        fontSize: 8,
      },
    },
  });

  function generateRows(data: Array<{
    date: string;
    no_employee: number;
    no_shift: number;
    shifts: Array<{
      shift_id: string;
      shift_name: string;
      shift_start: string | null;
      shift_end: string | null;
      employees: Array<{
        employee_code: number;
        employee_name: string;
        employee_position: string;
      }>;
    }>;
  }>) {
    const rows: any[][] = [];

    data.forEach(day => {
      let totalRowsForDate = 0;
      let datePrinted = false;

      day.shifts.forEach(shift => {
        totalRowsForDate += 1 + shift.employees.length;
      });
  
      day.shifts.forEach(shift => {
        rows.push([
          !datePrinted
            ? { text: day.date,
                rowSpan: totalRowsForDate,
                style: 'tableHeader', 
                alignment: "left", 
                font: "KanitLM" }
            : {},
  
          { text: shift.shift_id || " ", 
            style: 'tableHeader', 
            alignment: "left", 
            font: "KanitLM" },
          { text: shift.shift_name || " ", 
            style: 'tableHeader', 
            alignment: "left", 
            font: "KanitLM" },
          {},
          { text: shift.shift_start || " ", 
            style: 'tableHeader', 
            alignment: "center", 
            font: "KanitLM" },
          { text: shift.shift_end || " ", 
            style: 'tableHeader', 
            alignment: "center", 
            font: "KanitLM" },
        ]);
  
        datePrinted = true;
  
        shift.employees.forEach(emp => {
          rows.push([
            {},
            { text: emp.employee_code.toString(), 
                style: 'tableData', 
                alignment: "left", 
                font: "KanitLM" },
            { text: emp.employee_name, 
                style: 'tableData', 
                alignment: "left", 
                font: "KanitLM" },
            { text: emp.employee_position, 
                style: 'tableData', 
                alignment: "left", 
                font: "KanitLM" },
            {},
            {},
          ]);
        });
      });

      rows.push([
        { colSpan: 4, text: '', border: [false, true, false, false], style: 'summaryRow' },
        {}, {}, {},
        {
          text: [
            { text: 'No. of employee: ', bold: true },
            { text: `${day.no_employee} items` },
          ],
          style: 'summaryRow',
          alignment: 'center',
          font: 'KanitLM',
          border: [false, true, false, false],
          noWrap: true,
        },
        {
          text: [
            { text: 'No. of shift: ', bold: true },
            { text: `${day.no_shift} items` },
          ],
          style: 'summaryRow',
          alignment: 'center',
          font: 'KanitLM',
          border: [false, true, false, false],
          noWrap: true,
        },
      ]);
    });
  
    return rows;
  }

  const workScheduleTable: Content = {
    style: 'tableStyle',
    layout: {
      hLineWidth: (i, node) => {
        if (i === 0 || i === 2) return 0.5;

        const rowBefore = node.table.body[i - 1] as any[];
        const rowAfter = node.table.body[i] as any[];

        if (rowBefore && rowBefore.some(cell => cell.style === 'summaryRow')) return 0.5;

        if (rowAfter && rowAfter.some(cell => cell.style === 'summaryRow')) return 0.5;

        return 0;
      },
      vLineWidth: () => 0,
      hLineColor: () => 'gray',
      paddingTop: (i, node) => {
        if (i === 2) return 8;

        const rowBefore = node.table.body[i - 1] as any[];
        
        if (rowBefore && rowBefore.some(cell => cell.style === 'summaryRow')) {
          return 8;
        }
        return 2;
      }
    },
    table: {
      headerRows: 2,
      widths: ['12%', '17%', '25%', '12%', '18%', '16%'],
      heights: 20,
      body: [
        [
          {
            text: 'Date',
            rowSpan: 2,
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {
            text: 'Shift ID',
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {
            text: 'Shift name',
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {},
          {
            text: 'Shift start',
            rowSpan: 2,
            style: 'tableHeader',
            alignment: 'center',
            font: 'KanitLM',
          },
          {
            text: 'Shift end',
            rowSpan: 2,
            style: 'tableHeader',
            alignment: 'center',
            font: 'KanitLM',
          },
        ],
        [
          {},
          {
            text: 'Employee ID',
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {
            text: 'Employee name',
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {
            text: 'Position',
            style: 'tableHeader',
            alignment: 'left',
            font: 'KanitLM',
          },
          {},
          {},
        ],
        ...generateRows(props.fields)
      ],
    },
    margin: [20, 0, 20, 10]
  };

  return {
    pageSize: "A4",
    ...headerSapiensForm,
    content: [
      {
        ...workScheduleTable
      },
    ],
    styles: {
      ...headerSapiensForm.styles,
      tableHeader: {
        bold: true,
        fontSize: 8,
      },
      summaryRow: { 
        fontSize: 8, 
        margin: [0, 8, 0, 8] 
      },
      tableData: { fontSize: 8 },
      footerSignature: { fontSize: 9 },
      footerData: { fontSize: 8 },
    },
    footer: function (currentPage: number, pageCount: number) {
      return {
        margin: [20, 0, 20, 10],
        columns: [
          {
            text: `วันที่พิมพ์/Printed date: ${props.params.printed_date}`,
            font: "KanitLM",
            style: "footerData",
            alignment: "left",
            margin: [0, 5, 0, 0],
          },
          {
            text: "",
            width: "*",
          },
          {
            text: `Page ${currentPage} from ${pageCount}`,
            font: "KanitLM",
            style: "footerData",
            alignment: "right",
            margin: [0, 5, 0, 0],
          }
        ]
      };
    },
    images: {
      ...headerSapiensForm.images,
      background: origin + "/static/images/logoform/SAPIENS/HeaderSapiensForm.png",
    },
  };
};

export default FormWorkScheduleReport;
